import {createRouter, createWebHistory} from "vue-router"
import login from '../pages/login'
import OA from '../pages/OA'
import customers from '../pages/customers'
// import documents from '../pages/documents'
import orders from '../pages/orders'
import dashboard from '../pages/dashboard'
import Products from '../pages/Products'
import tracks from '../pages/tracks'
import settings from '../pages/settings'
import opportunities from '../pages/opportunities'
import quotation from '../pages/quotation'

const routerHistory = createWebHistory()
const routes = [
    { path: '/login', component: login, name: "login" },
    {
        path: '/',
        component: OA,
        name: "工作台",
        redirect: '/dashboard',
        children: [
            { path: 'dashboard', component: dashboard, name: "dashboard" },
            { path: 'customers', component: customers, name: "customers" },
            { path: 'opportunities', component: opportunities, name: "opportunities" },
            { path: 'tracks', component: tracks, name: "tracks" },
            { path: 'orders', component: orders, name: "orders" },
            { path: 'quotations', component: quotation, name: "quotations" },
            { path: 'documents', component: () => import('../pages/documents'), name: "单证管理" },
            { path: 'emaillog', component: () => import('../pages/emaillog'), name: "已发邮件" },
            { path: 'products', component: Products, name: "Products" },
            { path: 'product-categories', component: Products, name: "ProductCategories" },
            { path: 'settings', component: settings, name: "settings" }
        ]
    }
]

const router = createRouter({
    history: routerHistory,
    routes
})

export default router
